import { Box, Spacer, TextNew } from '@jfs/ui-new'
import { getRandomAlphaNumString, numberToLocalString } from '@jfs/utils'
import { default as React } from 'react'
import { ModBox } from '../../../comps/ModifiedBox/ModifiedBox'
import { leftComponent } from './LeftHeaderTextBox'

interface RenderItemProps {
  item: any
}

export const renderItem = ({ item }: RenderItemProps) => {
  const keyArray = Object.keys(item)
  const keyValue = Object.values(item)
  const isAmount = keyArray[0] === 'Amount'
  const isTimer = keyArray[0] === 'timer'
  const partialPayment = keyArray[0] === 'Partial Payment'

  const showOrHide = () => {
    if (keyValue[0] === '' || keyValue[0] === undefined) {
      return false
    } else if (isTimer) {
      return false
    } else if (partialPayment) {
      return false
    } else {
      return true
    }
  }

  return (
    <ModBox show={showOrHide()} flexDirection="row" pl="10%" key={getRandomAlphaNumString(3)}>
      <Box w="20%" pv={10}>
        <TextNew color="LIGHT_BLACK" type={'body12'} fontWeight="600">
          {keyArray[0]}
        </TextNew>
      </Box>
      <Box w="30%" pv={10} flexDirection="row" alignSelf="center">
        <ModBox show={isAmount}>
          {leftComponent()}
          <Spacer direction="horizontal" size={12} />
        </ModBox>
        <Box alignSelf="center" maxWidth={500}>
          <TextNew numberOfLines={3} type={'body12'}>
            {isAmount ? numberToLocalString(keyValue[0]) : keyValue[0]}
          </TextNew>
        </Box>
      </Box>
    </ModBox>
  )
}
